import { DateBox, TextArea, TextBox } from '../../shared/controls/form';
import SelectBox from '../../shared/controls/form/selectBox';
import { Form, Formik } from 'formik';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getActiveOwners, getGenericMasterFilteredListByKey } from '../../redux/selector';
import { validationSchemaTicket } from './validationSchema';
import PaginatedDropdown from '../../shared/component/PaginatedDropdown';
import apiServices from '../../services/service';
import DateTimePicker from '../../shared/controls/form/dateTimePicker';

const TaskForm = ({
  formData,
  selectedOptions,
  handleSubmit,
  handleChangeForm,
  handleChange,
  errormsg,
  handleDateTime,
}) => {
  const owner = useSelector(getActiveOwners);

  // For Lead
  const {
    options: leadListDropdown,
    isLoading: isLeadLoading,
    handleSearch: handleLeadSearch,
    handleScroll: handleLeadScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getLeadsDropdown, // your API function
    responseKey: 'leadList', // expected response key
  });

  // For Contact
  const {
    options: contactListDropdown,
    isLoading: isContactLoading,
    handleSearch: handleContactSearch,
    handleScroll: handleContactScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getContactsDropdown, // your API function
    responseKey: 'contactList', // expected response key
  });
  // Account dropdown
  const {
    options: accountListDropdown,
    isLoading: isAccountLoading,
    handleSearch: handleAccountSearch,
    handleScroll: handleAccountScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getAccountsDropdown, // Replace with actual API
    responseKey: 'accountList',
  });

  // Campaign dropdown
  const {
    options: campaignListDropdown,
    isLoading: isCampaignLoading,
    handleSearch: handleCampaignSearch,
    handleScroll: handleCampaignScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getCampaignDropdown,
    responseKey: 'campaignList',
  });

  // Opportunity dropdown
  const {
    options: opportunityListDropdown,
    isLoading: isOpportunityLoading,
    handleSearch: handleOpportunitySearch,
    handleScroll: handleOpportunityScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getOpportunityDropdown,
    responseKey: 'opportunityList',
  });

  const ticketStatusDropdown = useSelector(getGenericMasterFilteredListByKey('StatusCrm'));

  const ticketPriorityDropdown = useSelector(
    getGenericMasterFilteredListByKey('TicketPriorityCrm')
  );

  // State to manage the dark mode toggle and the popup visibility
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [showWithAnimation, setShowWithAnimation] = useState(false);

  const handleDone = () => {
    setPopupVisible(false);
    if (formData.reminder) {
      handleChangeForm({
        target: {
          name: 'reminder',
          value: formData.reminder,
        },
      });
    }
  };

  useEffect(() => {
    if (formData?.type === 'view' || formData?.type === 'edit') {
      // If there's a reminder set in the formData, turn on the toggle
      if (formData?.reminder) {
        setIsDarkMode(true);
      } else {
        setIsDarkMode(false);
      }
    } else {
      // For new tickets, always start with reminder off
      setIsDarkMode(false);
      // Also clear any existing reminder data
      if (formData?.reminder) {
        handleChangeForm({
          target: {
            name: 'reminder',
            value: '',
          },
        });
      }
    }
  }, [formData?.type]);

  const handleToggle = () => {
    const newDarkMode = !isDarkMode;
    setIsDarkMode(newDarkMode);

    // If turning off reminder, clear the reminder value
    if (!newDarkMode) {
      handleChangeForm({
        target: {
          name: 'reminder',
          value: null,
        },
      });
    } 

    if (!popupVisible && newDarkMode) {
      setPopupVisible(true);
      setTimeout(() => setShowWithAnimation(true), 100);
    } else {
      setShowWithAnimation(false);
      setTimeout(() => setPopupVisible(false), 300);
    }
  };

  // Handle Cancel button click
  const handleCancel = () => {
    setShowWithAnimation(false);
    if (popupVisible) {
      setTimeout(() => {
        setPopupVisible(false);
        setIsDarkMode(false); // Turn off the switch
      }, 300); // Delay hiding for animation out
    }
  };

  return (
    <Formik
      initialValues={formData}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={validationSchemaTicket}
    >
      <Form>
        <div className="collapse_card">
          <div className={formData?.type === 'view' ? 'addleadcard-view' : 'addleadcard'}>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/images/ticketInfo.svg" alt="" />
                      Tickets Information
                    </label>
                  </div>

                  <div className="leadcontent pd_card leadDetailInfo">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container  ">
                          <SelectBox
                            label={'Ticket Owner'}
                            name={'ownerId'}
                            placeholder={formData?.owner || 'Select Lead Owner'}
                            isRequired={true}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.ownerId}
                            handleSelect={handleChange}
                            options={owner}
                            optionKeys={['userId', 'userName']}
                            errormsg={errormsg?.ownerId}
                            nameFormatter={true}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container  ">
                          <TextBox
                            label={'Subject'}
                            name={'subject'}
                            isRequired={true}
                            placeholder={'Enter Subject'}
                            value={formData?.subject}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.subject}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <label>Due Date</label>
                          {formData?.type === 'view' && !formData?.dueDate ? (
                            <div>--</div>
                          ) : (
                            <div className="dtBox">
                              <DateBox
                                name={'dueDate'}
                                placeholder={'Enter Date'}
                                value={formData?.dueDate ? formData?.dueDate.substring(0, 10) : ''}
                                handleChange={handleChangeForm}
                                errormsg={errormsg?.dueDate}
                                disabled={formData?.type === 'view'}
                                minDate={new Date().toISOString().split('T')[0]}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <label htmlFor="#" className="selectlbl">
                            Ticket For
                          </label>
                          <div className="flexinput_container">
                            <div id="taskdropdown">
                              <div id="select_tsk">
                                <SelectBox
                                  name={'ticketId'}
                                  placeholder={
                                    formData?.type === 'view'
                                      ? formData?.ticket || '--'
                                      : formData?.ticket || 'Select'
                                  }
                                  optionKeys={['id', 'displayName']}
                                  options={[
                                    { id: 'lead', displayName: 'Lead' },
                                    { id: 'contact', displayName: 'Contact' },
                                  ]}
                                  handleSelect={handleChange}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                              {errormsg?.tasks && (
                                <span className="error-message">{errormsg?.tasks}</span>
                              )}
                            </div>
                            <div id="taskdropdown" className="nameID">
                              {formData?.ticket === 'Lead' && (
                                <SelectBox
                                  name="leadId"
                                  handleSelect={handleChange}
                                  placeholder={
                                    formData?.type === 'view'
                                      ? formData?.leadName || '--'
                                      : formData?.leadName || 'Select'
                                  }
                                  selectedOptions={selectedOptions?.leadId}
                                  options={leadListDropdown}
                                  isLoading={isLeadLoading}
                                  onScrollToBottom={handleLeadScroll}
                                  onSearch={handleLeadSearch}
                                  optionKeys={['id', 'fullName']}
                                  disabled={formData?.type === 'view'}
                                />
                              )}

                              {formData?.ticket === 'Contact' && (
                                <SelectBox
                                  name="contactId"
                                  handleSelect={handleChange}
                                  placeholder={
                                    formData?.type === 'view'
                                      ? formData?.contactName || '--'
                                      : formData?.contactName || 'Select'
                                  }
                                  selectedOptions={selectedOptions?.contactId}
                                  options={contactListDropdown}
                                  isLoading={isContactLoading}
                                  onScrollToBottom={handleContactScroll}
                                  onSearch={handleContactSearch}
                                  optionKeys={['id', 'name']}
                                  disabled={formData?.type === 'view'}
                                />
                              )}

                              {errormsg?.tasks && (
                                <span className="error-message">{errormsg?.tasks}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <label htmlFor="#" className="selectlbl">
                            {formData?.associate || '\u00A0'}
                          </label>
                          <div
                            className={`flexinput_container ${formData?.associate ? '' : 'd-block'}`}
                          >
                            <div className=" associatoption selectborder" id="accountdropdown">
                              {formData?.type !== 'view' && (
                                <div id="select_tsk">
                                  <SelectBox
                                    name="associateId"
                                    placeholder={
                                      formData?.type === 'view'
                                        ? formData?.associate || '--'
                                        : formData?.associate || 'Select'
                                    }
                                    handleSelect={handleChange}
                                    options={[
                                      { id: 'account', displayName: 'Account' },
                                      {
                                        id: 'opportunity',
                                        displayName: 'Opportunity',
                                      },
                                      {
                                        id: 'campaign',
                                        displayName: 'Campaign',
                                      },
                                    ]}
                                    optionKeys={['id', 'displayName']}
                                    disabled={
                                      formData?.ticket === 'Lead' || formData?.type === 'view'
                                    }
                                  />
                                </div>
                              )}
                            </div>
                            <div className=" selectbd viewselect" id="accountdropdown">
                              {formData.associate === 'Account' && (
                                <SelectBox
                                  name="accountId"
                                  value={formData.accounts}
                                  handleSelect={handleChange}
                                  placeholder={
                                    formData?.type === 'view'
                                      ? formData?.accountName || '--'
                                      : formData?.accountName
                                  }
                                  selectedOptions={selectedOptions?.accountId}
                                  options={accountListDropdown}
                                  isLoading={isAccountLoading}
                                  onScrollToBottom={handleAccountScroll}
                                  onSearch={handleAccountSearch}
                                  optionKeys={['id', 'name']}
                                  disabled={
                                    formData?.ticket === 'Lead' || formData?.type === 'view'
                                  }
                                />
                              )}

                              {formData.associate === 'Campaign' && (
                                <SelectBox
                                  id="contactSelect"
                                  name="campaignId"
                                  handleSelect={handleChange}
                                  placeholder={
                                    formData?.type === 'view'
                                      ? formData?.campaignName || '--'
                                      : formData?.campaignName
                                  }
                                  selectedOptions={selectedOptions?.campaignId}
                                  options={campaignListDropdown}
                                  isLoading={isCampaignLoading}
                                  onScrollToBottom={handleCampaignScroll}
                                  onSearch={handleCampaignSearch}
                                  optionKeys={['id', 'campaignName']}
                                  disabled={
                                    formData?.ticket === 'Lead' || formData?.type === 'view'
                                  }
                                />
                              )}

                              {formData.associate === 'Opportunity' && (
                                <SelectBox
                                  name="opportunityId"
                                  handleSelect={handleChange}
                                  placeholder={
                                    formData?.type === 'view'
                                      ? formData?.opportunityName || '--'
                                      : formData?.opportunityName
                                  }
                                  selectedOptions={selectedOptions?.opportunityId}
                                  options={opportunityListDropdown}
                                  isLoading={isOpportunityLoading}
                                  onScrollToBottom={handleOpportunityScroll}
                                  onSearch={handleOpportunitySearch}
                                  optionKeys={['id', 'name']}
                                  disabled={
                                    formData?.ticket === 'Lead' || formData?.type === 'view'
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ****************** */}

                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container " id="taskstatus">
                          <SelectBox
                            label={'Status'}
                            name={'statusId'}
                            value={formData?.status}
                            selectedOptions={selectedOptions?.statusId}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.status || '--'
                                : formData?.status || 'Select Status'
                            }
                            handleSelect={handleChange}
                            options={ticketStatusDropdown}
                            optionKeys={['id', 'displayName']}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container " id="taskpriority">
                          <SelectBox
                            label={'Priority'}
                            name={'priorityId'}
                            value={formData?.priority}
                            selectedOptions={selectedOptions?.priorityId}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.priority || '--'
                                : formData?.priority || 'Select Priority'
                            }
                            handleSelect={handleChange}
                            options={ticketPriorityDropdown}
                            optionKeys={['id', 'displayName']}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6">
                        <div
                          className="input-container"
                          style={{
                            position: 'relative',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}
                          id="remindpop"
                        >
                          <label htmlFor="#" className="selectlbl">
                            Reminder
                          </label>
                          <div className="remInputCon">
                            <div
                              className="toggle-container"
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={isDarkMode}
                                  onChange={handleToggle}
                                  disabled={formData?.type === 'view'}
                                />
                                <span className="slider"></span>
                              </label>
                              {/* Display selected reminder date/time */}
                              {formData.reminder && (
                                <span
                                  className="reminder-datetime"
                                  style={{
                                    marginLeft: '1rem',
                                    fontSize: '0.9rem',
                                    color: '#666',
                                  }}
                                >
                                  {new Date(formData.reminder).toLocaleString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: '2-digit',
                                    hour: 'numeric',
                                    minute: '2-digit',
                                    hour12: true,
                                  })}
                                </span>
                              )}
                            </div>

                            {/* Popup */}
                            {popupVisible && (
                              <div className="popup">
                                <div className="popup-content">
                                  <div className="showcontent" id="textinputview">
                                    <p>
                                      <span>On</span>{' '}
                                      <DateTimePicker
                                        value={formData.reminder}
                                        onChange={handleDateTime}
                                        name="reminder"
                                        placeholder="Select reminder date & time"
                                      />
                                    </p>
                                  </div>

                                  <div className="rightAction popupspacing">
                                    <button
                                      type="button"
                                      className="btn btn-outline-primary"
                                      onClick={handleCancel}
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={handleDone}
                                    >
                                      Done
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container  noteLabel">
                          <TextArea
                            label={'Description'}
                            name={'description'}
                            placeholder={'Enter Description'}
                            value={formData?.description}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.description}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default TaskForm;
